<div class="" [formGroup]="form" [ngClass]="{'card p-3': displayTitle}">
  <p *ngIf="displayTitle"><strong>Información general</strong></p>
  <div class="form-container mb-3">
    <div class="form-group" *ngIf="incidentID || isIncidentFile">
      <lib-datepicker
      [labelText]="'Fecha de inicio'"
      name="dateFrom"
      id="dateFrom"
      [useTime]="true"
      formControlName="dateTimeCreated"
      (ngModelChange)="applyFilters('dateFrom')"
      [maxDate]="today"
      [required]="incidentID"
      ></lib-datepicker>
    </div>
    <div class="form-group" *ngIf="incidentID || isIncidentFile">
      <lib-datepicker
      [labelText]="'Fecha de cierre'"
      name="dateTo"
      id="dateTo"
      [defaultToday]="false"
      [useTime]="true"
      [initCurrentTime]="!dateTimeClosed?.value?.Date?.Day ? true : false"
      formControlName="dateTimeClosed"
      [placeholder] ="'Fecha de cierre'"
      (ngModelChange)="applyFilters('dateTo')"
      [required]="false"
      ></lib-datepicker>
    </div>
    <div class="form-group">
      <label for="incidentType">Tipo</label>
      <custom-select
      formControlName="incidentType"
      [bordered]="true"
      name="incidentType"
      id="incidentType"
      [(sourceList)]="_incidentTypeList"
      (select)="onIncidentSubTypes(incidentType?.value?.value)"
      required
    ></custom-select>
    </div>
    <div class="form-group">
      <label for="incidentSubType">Detalle</label>
      <custom-select
        formControlName="incidentSubType"
        [bordered]="true"
        name="incidentSubType"
        id="incidentSubType"
        [(sourceList)]="_incidentSubTypeList"
        required
      ></custom-select>
    </div>
    <div class="form-group" >
      <label for="category">Categoría</label>
      <custom-select
        [filterEnabled]="true"
        [bordered]="true"
        name="category"
        id="category"
        formControlName="incidentCategoryColor"
        [(sourceList)]="incidentCategoryColorList"
        (select)="onChangeCategoryColor()"
        >
      </custom-select>
    </div>
    <div class="form-group" *ngIf="_displayControl">
      <custom-select
        [filterEnabled]="true"
        [labelText]="'Estado'"
        [bordered]="true"
        name="status"
        id="status"
        [disabled]="incidentID"
        formControlName="incidentStatus"
        [(sourceList)]="_incidentStatusList"
        required>
      </custom-select>
    </div>
    <div class="form-group" *ngIf="communicationID || isIncidentFile">
      <custom-select
        [filterEnabled]="true"
        [labelText]="'Medio'"
        [bordered]="true"
        name="incidentChannel"
        id="incidentChannel"
        formControlName="incidentChannel"
        [(sourceList)]="_incidentChannelList"
        required>
      </custom-select>
    </div>
    <div class="form-group" *ngIf="communicationID || isIncidentFile">
      <label for="reportingEntity">Informado por</label>
      <input
      type="text"
      name="reportingEntity"
      formControlName="reportingEntity"
      class="form-control"
      id="reportingEntity"
      >
    </div>
  </div>
</div>